const DEFAULT_PARAMETERS = {
  category: 3,
  theme: 3,
  posadka: 'channel',
  targeting: 'category',
  creative: ''
}

export const getFilterSearchParameters = () => {
  const url = new URL(location.href)
  const params = url.searchParams
  const isAvito = url.href.includes('avito')

  const theme = isAvito ? params.get('theme') : params.get('theme') ?? DEFAULT_PARAMETERS.theme
  const posadka = params.get('posadka') ?? DEFAULT_PARAMETERS.posadka
  const creative = params.get('creative') ?? DEFAULT_PARAMETERS.creative
  const targeting = params.get('targeting') ?? DEFAULT_PARAMETERS.targeting
  const region = params.get('region')
  const category = params.get('category') ?? DEFAULT_PARAMETERS.category
  const min = params.get('min')
  const max = params.get('max')

  const filterParams = Object.fromEntries(
    Object.entries({
      theme,
      posadka,
      region,
      category,
      targeting,
      creative,
      min,
      max
    }).filter(([_, v]) => v != null)
  ) as Record<string, string>

  return filterParams
}
